import { environment } from '../../environments/environment';
import { Utility } from './utility';
import { Injectable } from "@angular/core";
let payEndpoint = "APIM10_ENDPOINT";


const Apis = {
    'video-playnext': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'video/getnextvideo',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'video-downloadlink': {
        endpoint: 'API_ENDPOINT',
        path: 'video/GetDownloadLink',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'video-filter': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'video/filtervideobygold',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'recommended-lives': {
        endpoint: 'LIVE_ENDPOINT',
        path: 'home/gethotvideo',
        parameters: {
            cinema: environment.cinema,
            pz: 7,
            st: 1,
        }
    },
    'video-is-filter': {
        endpoint: 'API_ENDPOINT',
        path: 'video/IsUserFilter',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'slide-list': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'home/getflashbanner',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'video-list': {
        endpoint: 'API_ENDPOINT',
        path: 'list/index',
        parameters: {
            cinema: environment.cinema,
            page: 1,
            cid: 0,
            size: 10,
            isn: 0,
            isfree: -1
        }
    },
    'video-ranked-list': {
        endpoint: 'API_ENDPOINT',
        path: 'home/GetPlayRank',
        parameters: {
        }
    },
    'video-updated-list': {
        endpoint: 'API_ENDPOINT',
        path: 'home/GetRankOther',
        parameters: {
        }
    },
    'video-recent-updates': {
        endpoint: 'API_ENDPOINT',
        path: 'home/getrenewlist',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'video-last-added': {
        // endpoint: 'API_ENDPOINT',
        endpoint: 'APIM10_ENDPOINT',
        path: 'list/GetLastAdd',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'video-recently-watched': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'list/GetWatching',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'video-guess-you-like': {
        endpoint: 'APIM10_ENDPOINT',
        path: 'List/GuessYouLike',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'clear-hot-album-cache': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'List/ClearHotAlbumCache',
        parameters: {
        }
    },
    'video-related-list': {
        endpoint: 'RANK_ENDPOINT',
        path: 'home/getRelativeVideo',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'video-random-videos-by-category': {
        endpoint: 'API_ENDPOINT',
        path: 'home/getAllSubRandomVideoList',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'video-renew-videos-by-category': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'home/getWeekRenew',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'video-classified-top-videos-by-category': {
        // endpoint: 'API_ENDPOINT',
        endpoint: 'APIM10_ENDPOINT',
        path: 'list/getAllSubList',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'video-statistics': {
        endpoint: 'RANK_ENDPOINT',
        path: 'list/getVideoPie',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'video-popularity-trend': {
        endpoint: 'RANK_ENDPOINT',
        path: 'list/getVideoTrend',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'solr-search': {
        endpoint: 'APIV3RANK_ENDPOINT',
        path: 'list/briefsearch',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'user-search': {
        endpoint: 'APIV3RANK_ENDPOINT',
        path: 'list/searchUser',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'comment-list': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'video/commentList',
        parameters: {
            cinema: environment.cinema,
            id: '',
            page: 0,
            pagesize: 10,
            type: 1,
            a: 1
        }
    },
    'comment-like': {
        endpoint: 'APIM10_ENDPOINT',
        path: 'video/sayGood',
        parameters: {
            cinema: environment.cinema,
            pid: '',
        }
    },
    'comment-delete': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'video/commanddelete',
        parameters: {
            cinema: environment.cinema,
            type: 1,
        }
    },
    'comment-publish': {
        // endpoint: 'API_ENDPOINT',
        endpoint: 'APIM10_ENDPOINT',
        path: 'video/reply',
        parameters: {
            cinema: environment.cinema,
            type: 1,
        }
    },
    'comment-reply': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'video/replyto',
        parameters: {
            cinema: environment.cinema,
            type: 1,
        }
    },
    'get-comment-by-id': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'video/getcomminfobyid',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'get-comment-by-parentid': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'video/GetCommentByParentID',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'products': {
        endpoint: payEndpoint,
        path: 'payment/getPaymentInfo',
        parameters: {
            isPromotion: 3 // 3:砍价
        }
    },
    // 'customer-service-info': {
    //     endpoint: 'PUBLIC_ENDPOINT',
    //     path: 'price/pubinfos',
    //     parameters: {
    //     }
    // },
    'customer-service-info-chat': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'home/pubinfosall', 
        parameters: {
        }
    },
    'app-download': {
        endpoint: 'PUBLIC_ENDPOINT',
        path: 'price/appdownload',
        parameters: {
        }
    },
    'search': {
        endpoint: 'APIM10_ENDPOINT',
        path: 'list/Search',
        parameters: {
            cinema: environment.cinema,
            tags: '',
            page: 1,
            size: 10,
            orderby: 0,
            desc: 0,
        }
    },
    'search-filters': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'list/GetSearchCondition',
        parameters: {
        }
    },
    'search-tree': {
        endpoint: 'API_ENDPOINT',
        path: 'list/GetTree',
        parameters: {
        }
    },
    'tag-list': {
        endpoint: 'API_ENDPOINT',
        path: 'video/GetTagFilter',
        parameters: {
        }
    },
    'trending-searches': {
        endpoint: 'APIV3RANK_ENDPOINT',
        path: 'list/gethotsearchlist',
        parameters: {
            cinema: environment.cinema,
            size: 10,
        }
    },
    'suggested-searches': {
        endpoint: 'APIV3RANK_ENDPOINT',
        path: 'list/gethotsearchlist',
        parameters: {
            cinema: environment.cinema,
            size: 10,
        }
    },
    'short-video-list': {
        endpoint: 'NEWS_ENDPOINT',
        path: 'home/GetVideoList',
        parameters: {
            cinema: environment.cinema,
            size: 10,
        }
    },
    'most-popular-publishers': {
        endpoint: 'NEWS_ENDPOINT',
        path: 'home/GetTopUP',
        parameters: {
            cinema: environment.cinema,
            size: 12,
        }
    },
    'video-genre': { endpoint: 'API_ENDPOINT', path: 'list/FilmType', parameters: {} },
    'drama-genre': { endpoint: 'API_ENDPOINT', path: 'list/TvType', parameters: {} },
    'variety-genre': { endpoint: 'API_ENDPOINT', path: 'list/VarietyType', parameters: {} },
    'anime-genre': { endpoint: 'API_ENDPOINT', path: 'list/AnimeType', parameters: {} },
    'sport-genre': { endpoint: 'API_ENDPOINT', path: 'list/SportType', parameters: {} },
    'documentary-genre': { endpoint: 'API_ENDPOINT', path: 'list/DocumentaryType', parameters: {} },
    'chinese-genre': { endpoint: 'API_ENDPOINT', path: 'list/CircleType', parameters: {} },
    'game-genre': { endpoint: 'API_ENDPOINT', path: 'list/GameType', parameters: {} },
    'random-video-list': { endpoint: 'API_ENDPOINT', path: 'home/getrandomvideolist', parameters: { size: 5 } },
    'video-detail': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'video/detail',
        parameters: {
            ispath: false,
            cinema: environment.cinema,
            device: 'desktop',
            player: 'CkPlayer',
            tech: 'HLS',
            country: 'HU',
            lang: 'cns',
            v: 1,
        }
    },
    'video-last-play': {
        endpoint: 'API_ENDPOINT',
        path: 'video/getlastview',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'video-media': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'video/play',
        parameters: {
            cinema: environment.cinema,
            id: '',
            a: 1
        }
    },
    'videos-recommanded': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'home/getAllVideo',
        parameters: {
            cinema: environment.cinema,
            set: 1,
            size: 13
        }
    },
    'video-like': {
        endpoint: 'APIV3_ENDPOINT', path: 'video/videolike',
        parameters: {
            cinema: environment.cinema,
            videoID: '',
            type: 1,
        }
    },
    'video-dislike': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'video/videodislike',
        parameters: {
            cinema: environment.cinema,
            videoID: '',
            type: 1
        }
    },
    'video-favorite': {
        endpoint: 'APIM10_ENDPOINT',
        path: 'video/AddToScj',
        parameters: {
            cinema: environment.cinema,
            type: 1,
        }
    },
    'video-share': {
        endpoint: 'APIM10_ENDPOINT',
        path: 'Task/UpdTask',
        parameters: {
            cinema: environment.cinema,
            type: 1,
        }
    },
    'video-teaser-favorite': {
        endpoint: 'APIM10_ENDPOINT',
        path: 'video/AddToScj',
        parameters: {
            cinema: environment.cinema,
            type: 1,
        }
    },
    'video-remove-favorite': {
        endpoint: 'APIM10_ENDPOINT',
        path: 'video/removefromscj',
        parameters: {
            cinema: environment.cinema,
            type: 1,
        }
    },
    'video-unfavorite': {
        endpoint: 'API_ENDPOINT', path: 'list/RemoveFavorite',
        parameters: {
        }
    },
    'payment-get-orderinfo':
    {
        endpoint: payEndpoint,
        path: "payment/GetOrderInfo",
        parameters: {
        }
    },
    'user-auto': {
        endpoint: 'API_ENDPOINT',
        path: 'user/UserAutoLogin',
        parameters: {
        }
    },
    'blacklist': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'user/GetBlackList',
        parameters: {
        }
    },
    'addblacklist': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'user/InsertBlackList',
        parameters: {
        }
    },
    'removeblacklist': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'user/RemoveBlackList',
        parameters: {
        }
    },
    'clearblacklist': {
        endpoint: 'API_ENDPOINT',
        path: 'user/ClearBlackList',
        parameters: {
        }
    },
    /** 非当前用户 */
    'user-info': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'video/GetUserViewModel',
        parameters: {
            touid: ''
        }
    },
    'media-purchase': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'video/payvideobygold',
        parameters: {
            cinema: environment.cinema,
        }
    },
    /** 当前用户 */
    'authorized-user-info': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'user/getuserinfo',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'user-permissions': {
        endpoint: 'API_ENDPOINT',
        path: 'user/getuserext',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'user-favorites': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'list/favoritelist',
        parameters: {
            cid: '',
            cinema: environment.cinema,
            pageIndex: 1,
            pageSize: 24,
            key: 'added',
            order: 'DESC',
        }
    },
    'user-favorite-updates': {
        endpoint: 'APIM10_ENDPOINT',
        path: 'list/GetFavoriteNotify',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'user-favorite-attention-notify': {
        endpoint: 'APIV4_ENDPOINT',
        path: 'list/GetFavAttNotify',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'clear-favorite-updates': {
        endpoint: 'API_ENDPOINT',
        path: 'List/ClearFavoriteNotify',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'update-favorite-attention-notify': {
        endpoint: 'APIV4_ENDPOINT',
        path: 'list/UpdateFavAttNotify',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'clear-favorite-attention-updates': {
        endpoint: 'APIV4_ENDPOINT',
        path: 'List/ClearFavAttNotify',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'get-attention-notify': {
        endpoint: 'APIV4_ENDPOINT',
        path: 'List/GetAttentionNotify',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'get-favorite-notify': {
        endpoint: 'APIV4_ENDPOINT',
        path: 'List/GetFavoriteNotify',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'get-private-folder-settings': {
        endpoint: 'API_ENDPOINT',
        path: 'user/getuserprivate',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'check-private-secret': {
        endpoint: 'API_ENDPOINT',
        path: 'user/checkuserprivate',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'remove-user-favorites': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'list/RemoveFavorite',
        parameters: {
            cid: '',
            cinema: environment.cinema,
        }
    },
    'clear-user-favorites': {
        endpoint: 'API_ENDPOINT',
        path: 'List/ClearScj',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'user-token': {
        endpoint: 'API_ENDPOINT',
        path: 'user/getusertoken',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'watch-history': {
        endpoint: 'WEBAPIV3_ENDPOINT',
        path: 'PlayList/ObtainListWithCount',
        parameters: {
        }
    },
    'remove-watch-history': {
        endpoint: 'WEBAPIV3_ENDPOINT',
        path: 'PlayList/ClearsList',
        parameters: {}
    },
    'clear-watch-history': {
        endpoint: 'WEBAPIV3_ENDPOINT',
        path: 'PlayList/Truncate',
        parameters: {}
    },
    'user-messages': {
        endpoint: 'APIM10_ENDPOINT',
        path: 'list/messageslist',
        parameters: {
            cinema: environment.cinema,
            page: 1,
            a: 1
        }
    },
    'other-notifications': {
        endpoint: 'APIV4_ENDPOINT',
        path: 'List/GetSysMessageNotify',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'notifications': {
        endpoint: 'APIV4_ENDPOINT',
        path: 'List/GetUnReadSysMessage',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'mark-all-notifications-as-read': {
        endpoint: 'APIV4_ENDPOINT',
        path: 'List/MarkSystemRead',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'new-mark-all-notifications-as-read': {
        endpoint: 'APIV4_ENDPOINT',
        path: 'List/MarkSystemRead',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'mark-a-notifications-as-read': {
        endpoint: 'API_ENDPOINT',
        path: 'List/MarkSystemReadByID',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'mark-a-notifications-as-read-by-message-id': {
        endpoint: 'API_ENDPOINT',
        path: 'List/MarkNotifyReadByID',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'recharge-history': {
        endpoint: 'APIM10_ENDPOINT',
        path: 'list/rechargerecords',
        parameters: {
            cinema: environment.cinema,
            page: 1,
            pageSize: 10,
        }
    },
    'switch-region': {
        endpoint: 'API_ENDPOINT',
        path: 'home/getmyregion',
        parameters: {
            cinema: environment.cinema
        }
    },
    'payment-pay-order': {
        endpoint: 'API_ENDPOINT',
        path: 'payment/PayOrder',
        parameters: {
            cinema: environment.cinema
        }

    },
    'payment-create-order': {
        endpoint: payEndpoint,
        path: 'payment/createorder',
        parameters: {
            cinema: environment.cinema
        }
    },
    'payment-get-order': {
        endpoint: 'API_ENDPOINT',
        path: 'payment/getorder',
        parameters: {
            cinema: environment.cinema
        }
    },
    'payment-add-address': {
        endpoint: 'API_ENDPOINT',
        path: 'payment/addorupdateaddress',
        parameters: {
            cinema: environment.cinema
        }
    },
    'payment-get-address': {
        endpoint: 'API_ENDPOINT',
        path: 'payment/getaddress',
        parameters: {
            cinema: environment.cinema
        }
    },
    'payment-query-order': {
        endpoint: 'API_ENDPOINT',
        path: 'payment/QueryOrder',
        parameters: {
            cinema: environment.cinema
        }
    },
    'payment-generate-order': {
        endpoint: 'ACTIVITY_ENDPOINT',
        path: 'task/TransferGenerateOrder',
        parameters: {
            cinema: environment.cinema
        }
    },
    'payment-remove-address': {
        endpoint: 'API_ENDPOINT',
        path: 'payment/removeaddress',
        parameters: {
            cinema: environment.cinema
        }
    },
    'nav-main-links': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'list/mainMenuv2',
        parameters: {
            cinema: environment.cinema
        }
    },
    'nav-second-links': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'list/getHotVideoTop',
        parameters: {
            cinema: environment.cinema,
            pageSize: 10
        }
    },
    'all-ranked-videos': {
        endpoint: 'RANK_ENDPOINT',
        path: 'list/getAllHotVideoTop',
        parameters: {
            cinema: environment.cinema,
            pageSize: 10
        }
    },
    'recommended-news': {
        endpoint: 'NEWS_ENDPOINT',
        // path: 'home/gethotvideo',
        path: 'home/getnewhotvideo',
        parameters: {
            cinema: environment.cinema
        }
    },

    'vote-create': {
        endpoint: 'APIM10_ENDPOINT',
        path: 'video/postvote',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'vote-get-by-id': {
        endpoint: 'APIM10_ENDPOINT',
        path: 'video/getvotebyid',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'vote-vote-by-id': {
        endpoint: 'APIM10_ENDPOINT',
        path: 'video/votebyid',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'webforms': {
        endpoint: 'API_ENDPOINT',
        path: 'video/ReqAndOpinion',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'report': {
        endpoint: 'API_ENDPOINT',
        path: 'home/reportproblem',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'report-info': {
        endpoint: 'API_ENDPOINT',
        path: 'home/GetReportInfo',
        parameters: {
            cinema: environment.cinema,
        }
    },
    
    'problem-collect': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'user/ProblemCollect',
        parameters: {}
    },
    'languagesplaylist': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'video/languagesplaylist',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'help-get-categories': {
        endpoint: 'API_ENDPOINT',
        path: 'home/gethelpcat',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'help-get-content': {
        endpoint: 'API_ENDPOINT',
        path: 'home/gethelpcontent',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'help-get-content-by-id': {
        endpoint: 'API_ENDPOINT',
        path: 'home/gethelpcontentbyid',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'get-gg-block-content': {
        endpoint: 'PUBLIC_ENDPOINT',
        path: 'play/o',
        parameters: {
            cinema: environment.cinema,
        }
    },

    'get-adult-types': {
        endpoint: 'API_ENDPOINT',
        path: 'list/allinonetype',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'celebrities': {
        endpoint: 'API_ENDPOINT',
        path: 'list/starlist',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'get-barrages': {
        endpoint: 'APIM10_ENDPOINT',
        path: 'video/getBarrage',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'send-barrage': {
        endpoint: 'APIM10_ENDPOINT',
        path: 'video/addBarrage',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'remove-barrage': {
        endpoint: 'APIM10_ENDPOINT',
        path: 'video/removeBarrage',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'report-barrage': {
        endpoint: 'API_ENDPOINT',
        path: 'video/reportBarrage',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'like-barrage': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'video/BarrageLike',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'get-barrage-coin': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'video/GetBarrageCoin',
        parameters: {
            cinema: environment.cinema,
        }
    },
    "payment-generate-thirparty":
    {
        endpoint: 'ACTIVITY_ENDPOINT',
        path: 'task/TransferGenerateThirdPartyOrder',
        parameters: {
            cinema: environment.cinema,
        }
    },

    "danmu-user-settings":
    {
        endpoint: 'APIV3_ENDPOINT',
        path: 'user/getBarrageCofig',
        parameters: {
        }
    },
    "danmu-update-user-settings":
    {
        endpoint: 'APIV3_ENDPOINT',
        path: 'user/putBarrageCofig',
        parameters: {
        }
    },

    'related-channel':
    {
        endpoint: 'API_ENDPOINT',
        path: 'list/GetChannelList',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'report-comment': {
        endpoint: 'API_ENDPOINT',
        path: 'user/ReportUserReq',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'send-guide-done': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'user/UpdUserActionLog',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'all-video-genres': {
        endpoint: 'APIM10_ENDPOINT',
        path: 'list/AllVideoType',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'config': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'home/config',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'check-code': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'home/CheckCode',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'create-album': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'album/CreateAlbum',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'get-album': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'album/GetListAlbum',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'get-photo': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'album/GetAlbum',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'upload-album-photo': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'album/UploadBase64',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'edit-album': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'album/EditAlbum',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'set-album-sort': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'album/SetAlbumSort',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'delete-album': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'album/DelAlbum',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'delete-photo': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'album/DelPhoto',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'hot-count': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'album/Hot',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'move-photo': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'album/MovePhoto',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'like-album': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'album/Likes',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'create-move-photo': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'album/CreateMovePhoto',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'get-all-label': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'album/GetAllLabels',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'create-trends': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'trends/CreateTrends',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'upload-file': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'trends/UploadFile',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'get-meta-data': {
        endpoint: 'NEWS_ENDPOINT',
        path: 'video/GetMetaData',
        parameters: {
        }
    },
    'create-video-trends': {
        endpoint: 'NEWS_ENDPOINT',
        path: 'user/CreateTrends',
        parameters: {
        }
    },
    'get-list-trends': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'trends/GetListTrends',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'get-trends': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'trends/GetTrends',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'get-video-trends-list': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'trends/GetTrendsVideoList',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'delete-trends': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'album/DelAlbum',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'activity-view-count': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'album/Hot',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'like-activity': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'album/Likes',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'submit-big-v': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'user/ApplyForDoubleV',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'get-big-v': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'user/GetDoubleV',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'get-co-business': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'home/getCoBusiness',
        parameters: {
            cinema: environment.cinema,
        }
    },
    'get-person-mix': {
        endpoint: 'NEWS_ENDPOINT',
        path: 'user/PersonMix',
        parameters: {
        }
    },
    'get-user-attend-msg': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'user/GetUserAttendMsg',
        parameters: {
        }
    },
    'get-user-zan-msg': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'user/GetUserZanMsg',
        parameters: {
        }
    },
    'plus-one': {
        endpoint: 'WEBAPI_ENDPOINT',
        path: 'Counter/PlusOne',
        parameters: {
        }
    },
    'ablum-record-list': {
        endpoint: 'WEBAPIV3_ENDPOINT',
        path: 'playlist/AblumRecordList',
        parameters: {
        }
    },
    'ablum-search': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'album/SearchAlbum',
        parameters: {
        }
    },
    'get-ablum-labels': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'album/getlabels',
        parameters: {
        }
    },
    'get-hot-albums': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'album/GetHotAlbums',
        parameters: {
        }
    },
    'get-sub-album-list': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'album/GetSubAlbumList',
        parameters: {
        }
    },
    'get-album-flow-list': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'album/GetAlbumFlowList',
        parameters: {
        }
    },
    'get-sub-album-rnd-list': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'album/GetLabelRndList',
        parameters: {
        }
    },
    'get-hot-users': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'album/GetHotUsers',
        parameters: {
        }
    },
    'get-album-list-by-label': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'album/GetAlbumLabelList',
        parameters: {
        }
    },
    'get-album-sub-labels': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'album/GetSubLabels',
        parameters: {
        }
    },
    'get-rating-list': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'video/GetRatingList',
        parameters: {
        }
    },
    'get-user-setting': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'user/GetUserSetting',
        parameters: {
        }
    },
    'set-user-setting': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'user/SetUserSetting',
        parameters: {
        }
    },
    'reset-password': {
        endpoint: 'ANYGATE_ENDPOINT',
        path: 'user/ResetPsd',
        parameters: {
        }
    },
    'bind-info': {
        endpoint: 'ANYGATE_ENDPOINT',
        path: 'user/BindEmaMob',
        parameters: {
        }
    },
    'apply-code': {
        endpoint: 'ANYGATE_ENDPOINT',
        path: 'ThirdPartyLogin/MakeWebCode',
        parameters: {
        }
    },
    'is-valid-code': {
        endpoint: 'ANYGATE_ENDPOINT',
        path: 'ThirdPartyLogin/IsValidCode',
        parameters: {
        }
    },
    'update-mobile': {
        endpoint: 'ANYGATE_ENDPOINT',
        path: 'user/UpdMobile',
        parameters: {
        }
    },
    'update-avatar': {
        endpoint: 'ANYGATE_ENDPOINT',
        path: 'user/UpdateLogo',
        parameters: {
        }
    },
    'get-setting-user-info': {
        endpoint: 'ANYGATE_ENDPOINT',
        path: 'user/GetUserInfo',
        parameters: {
        }
    },
    'update-setting-user-info': {
        endpoint: 'ANYGATE_ENDPOINT',
        path: 'user/UpdUserInfo',
        parameters: {
        }
    },
    // 砍价
    'get-activity-info': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'bargain/GetActivityInfo',
        parameters: {
        }
    },
    'get-user-bargain-status': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'bargain/GetUserBargainStatus',
        parameters: {
        }
    },
    'join-bargain-activity': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'Bargain/JoinActivity',
        parameters: {
        }
    },
    'giveup-bargain-activity': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'Bargain/GiveUp',
        parameters: {
        }
    },
    'receive-for-free': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'Bargain/ReceiveForFree',
        parameters: {
        }
    },
    'get-bargain-unread': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'Bargain/BargainUnRead',
        parameters: {
        }
    },
    'has-read-bargain': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'Bargain/BargainRead',
        parameters: {
        }
    },
    'giveup-gift-bargain': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'Bargain/GiveUpBargain',
        parameters: {
        }
    },
    'get-gift-bargain': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'Bargain/GetBargainGiftByBID',
        parameters: {
        }
    },
    'set-bargain-gift': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'Bargain/SetBargainGiftByID',
        parameters: {
        }
    },
    'get-bargain-record': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'Bargain/BargainRecord',
        parameters: {
        }
    },
    'friend-help': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'Bargain/FriendHelp',
        parameters: {
        }
    },
    'system-help': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'Bargain/SystemHelp',
        parameters: {
        }
    },
    // 抽奖
    'get-prize-list': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'Bargain/GetPrize',
        parameters: {
        }
    },
    'get-chance-list': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'Bargain/DrawNumberList',
        parameters: {
        }
    },
    'get-chance-keys': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'Bargain/PrizeDrawByNumber',
        parameters: {
        }
    },
    'get-win-record': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'Bargain/WinRecord',
        parameters: {
        }
    },
    'make-prize-draw': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'Bargain/PrizeDraw',
        parameters: {
        }
    },
    'get-tv-live-list': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'Home/GetLiveList',
        parameters: {
        }
    },
    // 新主页菜单导航
    'new-main-menu': {
        endpoint: 'APIV3_ENDPOINT',
        path: 'list/MainMenuV3',
        parameters: {
            cinema: environment.cinema
        }
    },
};

@Injectable()
export class ApiUrlHelper {
    constructor(private _utility: Utility) {

    }


    public static toQueryString(obj) {
        var str = [];
        for (var p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(p + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    }

    public WEBAPI_ENDPOINT(v = "api") {
        return `https://w.anygate.vip/${v}`;
    }


    public NEWS_ENDPOINT(v = "api") {
        return this._utility.GetHost(`https://upload.{Host}/${v}`);
    }


    public API_ENDPOINT() {

        if (environment.cinema === 2) {
            return this._utility.GetHost('https://api8.{Host}/api');
        } else if (environment.app) {
            return this._utility.GetHost('https://m8.{Host}/api');
        } else {
            return this._utility.GetHost('https://m8.{Host}/api');
        }
    }

    public APIV3_ENDPOINT(version = 'v3') {
        if (environment.cinema === 2) {
            return this._utility.GetHost('https://api10.{Host}/' + version);
        } else if (environment.app) {
            return this._utility.GetHost('https://m10.{Host}/' + version);
        } else {
            return this._utility.GetHost('https://m10.{Host}/' + version);
        }
    }

    public APIV4_ENDPOINT(version = 'v3') {
        if (environment.cinema === 2) {
            return this._utility.GetHost('https://api10.{Host}/' + version);
        } else if (environment.app) {
            return this._utility.GetHost('https://m11.{Host}/' + version);
        } else {
            return this._utility.GetHost('https://m11.{Host}/' + version);
        }
    }

    public ACTIVITY_ENDPOINT() {
        // return this._utility.GetHost('https://activity.{Host}/api');
        return this._utility.GetHost('https://m10.{Host}/api');
    }


    public NEWSAPI_ENDPOINT() {
        return this._utility.GetHost("https://upload.{Host}/api");

    }

    public RANK_ENDPOINT(api = "api") {
        return this._utility.GetHost('https://rankv21.{Host}/' + api);
    }

    public PUBLIC_ENDPOINT() {
        return this._utility.GetHost('https://ppt.{Host}');
    }

    public ANYGATE_ENDPOINT(api = "api") {
        return `https://api.anygate.vip/${api}`;
    }

    public urlBuilder(name, para = {}, defEndpoint = "") {
        const api = Apis[name];
        this.clearAuthParams(api);
        let endpoint = defEndpoint || api.endpoint;
        switch (endpoint) {
            case ('API_ENDPOINT'): {
                endpoint = this.API_ENDPOINT();
                break;
            }
            case ('NEWS_ENDPOINT'): {
                endpoint = this.NEWS_ENDPOINT();
                break;
            }
            case ('NEWSV3_ENDPOINT'): {
                endpoint = this.NEWS_ENDPOINT("v3");
                break;
            }

            case ('WEBAPI_ENDPOINT'): {
                endpoint = this.WEBAPI_ENDPOINT();
                break;
            }
            case ('WEBAPIV3_ENDPOINT'): {
                endpoint = this.WEBAPI_ENDPOINT("v3");
                break;
            }

            case ('RANK_ENDPOINT'): {
                endpoint = this.RANK_ENDPOINT();
                break;
            }
            case ('PUBLIC_ENDPOINT'): {
                endpoint = this.PUBLIC_ENDPOINT();
                break;
            }
            case ('ANYGATE_ENDPOINT'): {
                endpoint = this.ANYGATE_ENDPOINT();
                break;
            }
            case ('APIV3_ENDPOINT'):
                {
                    endpoint = this.APIV3_ENDPOINT();
                    break;
                };
            case ('APIV4_ENDPOINT'):
                {
                    endpoint = this.APIV4_ENDPOINT();
                    break;
                };
            case ('APIV3RANK_ENDPOINT'):
                {
                    endpoint = this.RANK_ENDPOINT("v3");
                    break;
                };
            case ('APIM10_ENDPOINT'): {
                endpoint = this.APIV3_ENDPOINT("api");
                break;
            }
            case ('ACTIVITY_ENDPOINT'): {
                endpoint = this.ACTIVITY_ENDPOINT();
                break;
            }
            case "LIVE_ENDPOINT":
                endpoint = "https://api.miolive.tv/api"
                break;
        }
        var path = api.path;
        let res = endpoint + '/' + path;
        var apiObj = Object.assign({}, api.parameters, para);
        const queries = [];
        for (const key in apiObj) {
            if (apiObj.hasOwnProperty(key)) {
                if (apiObj[key] || apiObj[key] === 0) {
                    queries.push(key + '=' + apiObj[key]);
                }
            }
        }
        if (queries.length) {
            res = res + '?' + queries.join('&');
        }
        return res;
    }

    clearAuthParams(api) {
        if (api != null) {
            delete api.parameters['expire'];
            delete api.parameters['gid'];
            delete api.parameters['sign'];
            delete api.parameters['token'];
            delete api.parameters['uid'];
        }

    }
}


export class UrlQueryParams {
    body = {};
    list = {};
    constructor() {

    }
    set(key, value) {
        this.body[key] = value;
    }
    append(key, value) {
        if (!this.list[key]) {
            this.list[key] = [];
        }
        this.list[key].push(value);
    }
    toString() {
        let result = ApiUrlHelper.toQueryString(this.body);

        for (var i in this.list) {
            for (var j in this.list[i]) {
                if (result) {
                    result += "&";
                }
                result += i + "=" + encodeURIComponent(this.list[i][j]);
            }
        }
        return result;
    }
}
